import { useQuery } from '@tanstack/react-query';
import { useShippingMethodsApi } from './use-shipping-methods-api';

/**
 * Query key for listing shipping methods
 */
export const QK_LIST_SHIPPING_METHODS = () => ['shipping-methods'] as const;

export function useShippingMethods() {
  const { shippingMethodsApi } = useShippingMethodsApi();

  const query = useQuery({
    queryKey: QK_LIST_SHIPPING_METHODS(),
    queryFn: () => shippingMethodsApi.list(),
  });

  return {
    ...query,
    data: query.data ?? [],
  };
}
